import {Map} from 'immutable';

import {GuessModelV1} from 'resources/augmented/Guess/GuessModel.v1';

/**
 * Single source of truth for a display-only "empty guess" — no content, incorrect, zero points.
 *
 * Referenced by the legacy base store's `buildEmptyGuess` and by the assignment view's
 * `buildEmptyGuessForQuestion` (which builds it for the zustand-backed item-bank/ordering
 * stores, since those don't implement the legacy `buildEmptyGuess`).
 */
export function createEmptyGuess(question: any) {
  return new GuessModelV1({
    content: Map(),
    correct: false,
    points_earned: 0,
    question_v1: question
  });
}
